// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"ea2a64f122d0f866","962":"748b8af06e852538"}[chunkId] + ".css";
};